import { render, staticRenderFns } from "./CreateGupshupChannel.vue?vue&type=template&id=dc7619aa&scoped=true"
import script from "./CreateGupshupChannel.vue?vue&type=script&lang=js"
export * from "./CreateGupshupChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateGupshupChannel.vue?vue&type=style&index=0&id=dc7619aa&prod&lang=scss&scoped=true"
import style1 from "./CreateGupshupChannel.vue?vue&type=style&index=1&id=dc7619aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7619aa",
  null
  
)

export default component.exports